import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M22.5.25h-7.64a1.25 1.25 0 0 0 0 2.5H16a.26.26 0 0 1 .22.13.25.25 0 0 1 0 .25L4.78 21a.5.5 0 0 1-.42.23H1.5a1.25 1.25 0 0 0 0 2.5h7.64a1.25 1.25 0 0 0 0-2.5H8.05a.26.26 0 0 1-.22-.13.27.27 0 0 1 0-.26L19.22 3a.5.5 0 0 1 .42-.23h2.86a1.25 1.25 0 0 0 0-2.5Z"
    }, null, -1)
  ]));
}
const EditorItalic = { render };
export {
  EditorItalic as default,
  render
};
//# sourceMappingURL=EditorItalic.svg.js.map
